import { useParams } from 'react-router-dom';

import { parseFormUrlSegment } from '@vyce/core/src/utils/formUrl';

type FormRouteParam = 'id' | 'templateId';

export function useFormRouteSegment(paramKey: FormRouteParam = 'id') {
  const params = useParams<{ id?: string; templateId?: string }>();
  const segment = (paramKey === 'templateId' ? params.templateId : params.id) ?? '';
  const { id } = parseFormUrlSegment(segment);
  return { segment, id };
}
